import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import homepageImage1 from "../../images/homePageImages/homepageimage1.png";
import homepageImage10 from "../../images/homePageImages/homepageimage10.png";
import homepageImage8 from "../../images/homePageImages/homepageimage8.png";
import homepageImage11 from "../../images/homePageImages/homepageimage11.png";

import "./businessLanding.css";
import PhoneCarousel from "../common/phoneCarousel/PhoneCarousel";

const BusinessLanding = () => {
    const { language } = useContext(CombinedContext);
    const navigate = useNavigate();

    return (
        <div>
            <section className="sf-bl-hero">
                <div className="sf-bl-hero-sub-div">
                    <div className="sf-bl-hero-left">
                        <h1>{translations[language].businessLanding.hero.title}</h1>

                        <p>{translations[language].businessLanding.hero.subtitle}</p>

                        <div className="sf-bl-hero-buttons">
                            <button className="sf-bl-btn-primary" onClick={() => navigate("/listyourshop")}>
                                {translations[language].businessLanding.hero.primaryCta}
                            </button>

                            <div className="sf-bl-store">{translations[language].businessLanding.hero.storeText}</div>
                        </div>

                        <p className="sf-bl-hero-note">
    <em>
        <strong>{translations[language].businessLanding.hero.noteStrong}</strong>
        {translations[language].businessLanding.hero.noteRest}
    </em>
</p>
                    </div>

                    <img src={homepageImage10} alt="" className="sf-bl-hero-img" />
                </div>
            </section>
            <div className="sf-bl-page">
                {/* PROBLEM */}

                <section className="sf-bl-problem">
                    <h2>{translations[language].businessLanding.problem.title}</h2>

                    <div className="sf-bl-problem-grid">
                        <div className="sf-bl-problem-grid-sub-div">
                            <h3 className="sf-bl-problem-grid-sub-div-title">{translations[language].businessLanding.problem.subtitle}</h3>

                            <ul>
                                {translations[language].businessLanding.problem.items.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </div>

                        <div className="sf-bl-problem-arrow"></div>

                        <div>
                            <p className="sf-bl-problem-desc">
								<strong>
                                {translations[language].businessLanding.problem.description}
								</strong>
                            </p>

							<ul>
                                {translations[language].businessLanding.problem.itemspart2.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
							

                            <div className="sf-bl-problem-highlight">
                                {translations[language].businessLanding.problem.highlight}
                            </div>
                        </div>
                    </div>
                </section>

                {/* DID YOU KNOW */}

                <section className="sf-bl-didyouknow">
                    <h2>{translations[language].businessLanding.didYouKnow.title}</h2>

                    <div className="sf-bl-didyouknow-grid">
                        <div>
                            <ul>
                                {translations[language].businessLanding.didYouKnow.items.map((item, i) => (
                                    <li key={i}>• {item}</li>
                                ))}
                            </ul>

                            <div className="sf-bl-didyouknow-highlight">
                                {translations[language].businessLanding.didYouKnow.highlight}
                            </div>
                        </div>

                        <img src={homepageImage8} alt="" className="sf-bl-main-img-tall" />
                    </div>
                </section>

                {/* SOLUTION */}

                <section className="sf-bl-solution">
                <div className="sf-homelanding-text-div">
                    <h2>{translations[language].businessLanding.solution.title}</h2>

                    <div className="sf-bl-solution-grid">
                        <div>
                            <ul>
                                {translations[language].businessLanding.solution.points.map((p, i) => (
                                    <li key={i}>
                                        <span>{i + 1}</span>
                                        <div>
                                            <strong className="sf-homelanding-text strong">{p.title}</strong>
                                            <p className="sf-homelanding-text">{p.desc}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        
                    </div>
                    </div>
                    <PhoneCarousel/>
                </section>

                {/* PRICING */}

                <section className="sf-bl-pricing">
                    <h2>{translations[language].businessLanding.pricing.title}</h2>

                    <div className="sf-bl-pricing-grid">
                        <div className="sf-bl-pricing-card">
                            <h3>{translations[language].businessLanding.pricing.planTitle}</h3>

                            <ul>
                                {translations[language].businessLanding.pricing.planItems.map((p, i) => (
                                    <li key={i}>{p}</li>
                                ))}
                            </ul>

                            <p className="sf-bl-pricing-note">{translations[language].businessLanding.pricing.note}</p>
                        </div>

                        <div className="sf-bl-pricing-card-other">
                            <h3>{translations[language].businessLanding.pricing.autoTitle}</h3>

                            <ul>
                                {translations[language].businessLanding.pricing.autoItems.map((a, i) => (
                                    <li key={i}>• {a}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </section>

                {/* REFERRAL */}

                <section className="sf-bl-referral">
                    <div className="sf-bl-referral-banner">
                        {translations[language].businessLanding.referral.banner}
                    </div>

                    <div className="sf-bl-referral-grid">
                        <img src={homepageImage11} alt="" className="sf-bl-main-img-wide" />

                        <ul>
                            {translations[language].businessLanding.referral.steps.map((s, i) => (
                                <li key={i}>{s}</li>
                            ))}
                        </ul>
                    </div>
                </section>

                {/* FINAL CTA */}

                <section className="sf-bl-final">
                    <p>{translations[language].businessLanding.final.text}</p>

                    <button className="sf-bl-btn-primary" onClick={() => navigate("/listyourshop")}>
                        {translations[language].businessLanding.final.button}
                    </button>
                </section>
            </div>
        </div>
    );
};

export default BusinessLanding;

// import React, { useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import { CombinedContext } from "../../context/combinedContext";
// import translations from "../../translations/translations";
// import { CheckCircle } from "lucide-react";
// import "./businessLanding.css";

// const BusinessLanding = () => {
// 	const { language } = useContext(CombinedContext);
// 	const navigate = useNavigate();

// 	return (
// 		<div className="sf-businesslanding-page">
// 			{/* HERO */}
// 			<section className="sf-businesslanding-hero">
// 				<h1>{translations[language].businessLanding.hero.title}</h1>
// 				<p>{translations[language].businessLanding.hero.subtitle}</p>

// 				<div className="sf-businesslanding-hero-actions">
// 					<button className="btn brand" onClick={() => navigate("/listyourshop")}>
// 						{translations[language].businessLanding.hero.primaryCta}
// 					</button>
// 					{/* <button className="btn outline" onClick={() => navigate("/explore")}>
// 						{translations[language].businessLanding.hero.secondaryCta}
// 					</button> */}
// 				</div>
// 			</section>

// 			{/* REAL PROBLEM */}
// 			<section className="sf-businesslanding-section sf-businesslanding-light">
// 				<h2>{translations[language].businessLanding.problem.title}</h2>

// 				<ul className="sf-businesslanding-problem-list">
// 					{translations[language].businessLanding.problem.items.map((item, idx) => (
// 						<li key={idx}>{item}</li>
// 					))}
// 				</ul>

// 				<div className="sf-businesslanding-highlight">
// 					{translations[language].businessLanding.problem.highlight}
// 				</div>

// 				<p className="sf-businesslanding-stat">
// 					{translations[language].businessLanding.problem.stat}
// 				</p>
// 			</section>

// 			{/* HOW SIN FILA HELPS */}
// 			<section className="sf-businesslanding-section">
// 				<h2>{translations[language].businessLanding.solution.title}</h2>

// 				<div className="sf-businesslanding-columns">
// 					<div className="sf-businesslanding-card">
// 						<h3>
// 							{translations[language].businessLanding.solution.business.title}
// 						</h3>
// 						<ul>
// 							{translations[language].businessLanding.solution.business.items.map(
// 								(item, idx) => (
// 									<li key={idx}>
// 										<CheckCircle size={18} /> {item}
// 									</li>
// 								)
// 							)}
// 						</ul>
// 					</div>

// 					<div className="sf-businesslanding-card">
// 						<h3>
// 							{translations[language].businessLanding.solution.clients.title}
// 						</h3>
// 						<ul>
// 							{translations[language].businessLanding.solution.clients.items.map(
// 								(item, idx) => (
// 									<li key={idx}>
// 										<CheckCircle size={18} /> {item}
// 									</li>
// 								)
// 							)}
// 						</ul>
// 					</div>
// 				</div>
// 			</section>

// 			{/* VISUAL ELEMENTS */}
// 			<section className="sf-businesslanding-section sf-businesslanding-light">
// 				<h2>{translations[language].businessLanding.visuals.title}</h2>

// 				<div className="sf-businesslanding-visual-grid">
// 					{translations[language].businessLanding.visuals.items.map((item, idx) => (
// 						<div key={idx} className="sf-businesslanding-visual">
// 							{item}
// 						</div>
// 					))}
// 				</div>
// 			</section>

// 			{/* PRICING */}
// 			<section className="sf-businesslanding-section">
// 				<h2>{translations[language].businessLanding.pricing.title}</h2>

// 				<div className="sf-businesslanding-pricing-card">
// 					<h3>{translations[language].businessLanding.pricing.mainPrice}</h3>
// 					<p>{translations[language].businessLanding.pricing.mainDesc}</p>

// 					<h4>{translations[language].businessLanding.pricing.extraPrice}</h4>
// 					<p>{translations[language].businessLanding.pricing.extraDesc}</p>

// 					<ul>
// 						{translations[language].businessLanding.pricing.includes.map(
// 							(item, idx) => (
// 								<li key={idx}>{item}</li>
// 							)
// 						)}
// 					</ul>

// 					<p className="sf-businesslanding-note">
// 						{translations[language].businessLanding.pricing.note}
// 					</p>
// 				</div>

// 				<div className="sf-businesslanding-referral">
// 					{translations[language].businessLanding.pricing.referral}
// 				</div>
// 			</section>

// 			{/* FINAL CTA */}
// 			<section className="sf-businesslanding-final">
// 				<h2>{translations[language].businessLanding.final.title}</h2>
// 				<p>{translations[language].businessLanding.final.subtitle}</p>

// 				<button
// 					className="btn brand large"
// 					onClick={() => navigate("/listyourshop")}
// 				>
// 					{translations[language].businessLanding.final.cta}
// 				</button>

// 				<div className="sf-businesslanding-stores">
// 					<p>{translations[language].businessLanding.final.storeText}</p>
// 					<div className="sf-businesslanding-store-row">
// 						<div className="sf-businesslanding-store">App Store</div>
// 						<div className="sf-businesslanding-store">Google Play</div>
// 					</div>
// 				</div>
// 			</section>
// 		</div>
// 	);
// };

// export default BusinessLanding;
